import { render, staticRenderFns } from "./GlobalStat.vue?vue&type=template&id=36c1f71a&scoped=true"
import script from "./GlobalStat.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalStat.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalStat.vue?vue&type=style&index=0&id=36c1f71a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1f71a",
  null
  
)

export default component.exports